(function () {
  if (!window.location.pathname.endsWith('/collections/nippers-and-knives')) {
    return;
  }

  const grid = document.getElementById('product-grid');
  if (!grid) {
    return;
  }

  const items = grid.querySelectorAll('.grid__item[data-ovs-cut-category]');
  const pagination = document.querySelector('.pagination-wrapper');

  function parseList(param) {
    const raw = new URLSearchParams(window.location.search).get(param);
    if (!raw) {
      return [];
    }

    return raw
      .split(',')
      .map((value) => value.trim())
      .filter((value) => value !== '');
  }

  const NIPPER_TIER_ALIASES = {
    starter: 'beginner',
    enthusiast: 'intermediate',
    advanced: 'expert',
  };

  function normalizeNipperTier(tier) {
    if (!tier) {
      return '';
    }

    return NIPPER_TIER_ALIASES[tier] || tier;
  }

  function parseNipperTier() {
    return normalizeNipperTier(new URLSearchParams(window.location.search).get('ovs_nipper_tier') || '');
  }

  function nipperTierFromPriceCents(rawCents) {
    const cents = Number.parseInt(rawCents || '', 10);
    if (Number.isNaN(cents)) {
      return null;
    }

    if (cents < 2000) {
      return 'beginner';
    }

    if (cents < 4000) {
      return 'intermediate';
    }

    return 'expert';
  }

  function selectedCategories() {
    return [...document.querySelectorAll('.ovs-cut-category-input:checked')]
      .map((input) => input.dataset.ovsCutCategory || '')
      .filter((value) => value !== '');
  }

  function selectedStyles() {
    return [...document.querySelectorAll('.ovs-cut-style-input:checked')]
      .map((input) => input.dataset.ovsCutStyle || '')
      .filter((value) => value !== '');
  }

  function itemStyles(item) {
    const raw = item.dataset.ovsCutStyles || '';
    if (!raw) {
      return [];
    }

    return raw
      .split(',')
      .map((value) => value.trim())
      .filter((value) => value !== '');
  }

  function syncCheckboxLabels() {
    document.querySelectorAll('.ovs-cut-category-input').forEach((input) => {
      const label = input.closest('.ovs-cut-category-option');
      if (label) {
        label.classList.toggle('active', input.checked);
      }
    });

    document.querySelectorAll('.ovs-cut-style-input').forEach((input) => {
      const label = input.closest('.ovs-cut-style-option');
      if (label) {
        label.classList.toggle('active', input.checked);
      }
    });
  }

  function syncCheckboxesFromUrl() {
    const categories = parseList('ovs_cut_category');
    const styles = parseList('ovs_cut_style');

    document.querySelectorAll('.ovs-cut-category-input').forEach((input) => {
      const category = input.dataset.ovsCutCategory || '';
      input.checked = categories.includes(category);
    });

    document.querySelectorAll('.ovs-cut-style-input').forEach((input) => {
      const style = input.dataset.ovsCutStyle || '';
      input.checked = styles.includes(style);
    });

    syncCheckboxLabels();
  }

  function buildUrl(categories, styles) {
    const url = new URL(window.location.href);
    const existingTier = parseNipperTier();
    url.searchParams.delete('ovs_cut_category');
    url.searchParams.delete('ovs_cut_style');
    url.searchParams.delete('ovs_nipper_tier');
    url.searchParams.delete('page');

    if (categories.length > 0) {
      url.searchParams.set('ovs_cut_category', categories.join(','));
    }

    if (styles.length > 0) {
      url.searchParams.set('ovs_cut_style', styles.join(','));
    }

    if (existingTier !== '' && categories.includes('nipper')) {
      const publicTier =
        Object.entries(NIPPER_TIER_ALIASES).find(([, internal]) => internal === existingTier)?.[0] ||
        existingTier;
      url.searchParams.set('ovs_nipper_tier', publicTier);
    }

    return url;
  }

  function updateProductCount(visibleCount) {
    const countNodes = document.querySelectorAll(
      '#ProductCountDesktop, #ProductCountMobile, .product-count__text span',
    );
    countNodes.forEach((node) => {
      if (visibleCount === 1) {
        node.textContent = '1 product';
      } else {
        node.textContent = visibleCount + ' products';
      }
    });
  }

  function togglePagination(categories, styles, nipperTier) {
    if (!pagination) {
      return;
    }

    pagination.hidden = categories.length > 0 || styles.length > 0 || nipperTier !== '';
  }

  function applyFilters(updateHistory) {
    const categories = selectedCategories();
    const styles = selectedStyles();
    const nipperTier = parseNipperTier();
    let visibleCount = 0;

    items.forEach((item) => {
      const itemCategory = item.dataset.ovsCutCategory || '';
      const itemStyleList = itemStyles(item);
      let show = true;

      if (categories.length > 0) {
        show = categories.includes(itemCategory);
      }

      if (show && styles.length > 0) {
        show = itemStyleList.length > 0 && styles.some((style) => itemStyleList.includes(style));
      }

      if (show && nipperTier && itemCategory === 'nipper') {
        show = nipperTierFromPriceCents(item.dataset.ovsPriceCents) === nipperTier;
      }

      item.hidden = !show;
      if (show) {
        visibleCount += 1;
      }
    });

    syncCheckboxLabels();
    updateProductCount(visibleCount);
    togglePagination(categories, styles, nipperTier);

    if (updateHistory) {
      const url = buildUrl(categories, styles);
      window.history.pushState({ ovsCutFilters: true }, '', url.pathname + url.search);
    }
  }

  document.querySelectorAll('.ovs-cut-category-input, .ovs-cut-style-input').forEach((input) => {
    input.addEventListener('change', () => {
      applyFilters(true);
    });
  });

  window.addEventListener('popstate', () => {
    syncCheckboxesFromUrl();
    applyFilters(false);
  });

  syncCheckboxesFromUrl();
  applyFilters(false);
})();
